import IndexPage from '@dex/bubl-dash/src/lib/pages/IndexPage';
import PushNotificationCreateEditForm from './Components/PushNotificationCreateEditForm';
import PushNotificationApi from './PushNotificationApi';

export default function (app, settings) {

    app.addRoute({
        name: settings.key + "New",
        zone: settings.zone,
        path: settings.key + "/create",
        caps: settings.createCaps,
        component: IndexPage,
        componentProps: {
            header: {
                getTitle: () => "Add New",
                getButtons: settings.indexButtons,
                getTabs: settings.indexTabs,
                getTabCounts: settings.indexTabCounts,
            },
            create: {
                form: PushNotificationCreateEditForm,
                getCreate: PushNotificationApi.create,
                defaults: { link: { id: null, screen: null } },
                successMessage: "Push Notification Saved",
                successRouteName: settings.key + "View",
                idKey: settings.idKey
            }
        },
    });

}